import React, { useState, useEffect } from 'react';
import { intelSubscribe, getIntelSubscriberCount } from '../../services/plansApi';
import { trackIntelEmailSubscribed } from '../../hooks/useAnalytics';
import { Mail, Check } from 'lucide-react';
import './IntelEmailCapture.css';

const IntelEmailCapture: React.FC = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');
  const [subscriberCount, setSubscriberCount] = useState<number | null>(null);

  useEffect(() => {
    getIntelSubscriberCount()
      .then(data => setSubscriberCount(data.count))
      .catch(() => {});
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setError('');
    try {
      const result = await intelSubscribe({ email });
      trackIntelEmailSubscribed();
      setSubmitted(true);
      setSubscriberCount(result.subscriber_count);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to subscribe');
    }
  };

  if (submitted) {
    return (
      <div className="intel-email-capture success">
        <Check size={24} className="intel-email-icon" />
        <p className="intel-email-message">You&apos;re in! Travel intel drops weekly.</p>
      </div>
    );
  }

  return (
    <div className="intel-email-capture">
      <Mail size={20} className="intel-email-icon" />
      <p className="intel-email-heading">Get weekly travel intel</p>
      <p className="intel-email-sub">Price drops, timing windows, and destination signals.</p>
      <form className="intel-email-form" onSubmit={handleSubmit}>
        <input
          type="email"
          className="intel-email-input"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          aria-label="Email for travel intel"
        />
        <button type="submit" className="intel-email-btn">Subscribe</button>
      </form>
      {error && <p className="intel-email-error">{error}</p>}
      {subscriberCount !== null && subscriberCount > 0 && (
        <p className="intel-email-count">{subscriberCount.toLocaleString()} subscribers</p>
      )}
    </div>
  );
};

export default IntelEmailCapture;
